import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCO: CultureInfo = {
  name: 'en-CO',
  displayName: 'English (Colombia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CO',
  parent: CultureInfoEn
};
